import React from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import nafsa from "../../../../assets/png/Logoes/nafsa.png";
import ola from "../../../../assets/png/Logoes/ola.png";
import { ReactComponent as Feather } from "../../../../assets/landing/patria-feather.svg";
import { routes } from "../../../../routes/Application/routes";

/**
 * The reference footer is a single slim row: copyright on the left, Terms /
 * Privacy / Details on the right.
 *
 * The NAFSA and OLA membership marks are kept, unlike the reference. Dropping
 * lender membership badges is a compliance decision, not a styling one, so they
 * are retained here until legal signs off on removing them.
 *
 * `tone` picks the surface: "light" for the v1 lander, "dark" for v2's ink footer.
 */
const Wrapper = styled.footer<{ $dark: boolean }>`
  border-top: 1px solid
    ${(props) => (props.$dark ? "transparent" : "rgba(0, 0, 0, 0.05)")};
  background: ${(props) => (props.$dark ? "var(--brand-ink)" : "#fff")};
  padding: 32px 0;

  .inner {
    margin: 0 auto;
    max-width: 1152px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    padding: 0 20px;
    font-size: 12px;
    color: ${(props) =>
      props.$dark ? "rgba(255, 255, 255, 0.5)" : "rgba(14, 17, 22, 0.5)"};
  }

  .copy {
    display: flex;
    align-items: center;
    gap: 8px;

    svg {
      width: 16px;
      height: 16px;
      color: var(--brand-red);
      flex-shrink: 0;
    }
  }

  .badges {
    display: flex;
    align-items: center;
    gap: 16px;

    img {
      height: 32px;
      width: auto;
    }
  }

  .links {
    display: flex;
    gap: 20px;

    a {
      color: inherit;
      text-decoration: none;
      transition: color 0.2s;
      /* pads the legal links out to a ~32px tap target without shifting the
       * row's visual height (the flex row is taller than the text anyway) */
      padding: 8px 0;

      &:hover {
        color: ${(props) => (props.$dark ? "#fff" : "var(--brand-red)")};
      }
    }
  }

  @media screen and (min-width: 640px) {
    .inner {
      flex-direction: row;
      padding: 0 32px;
    }
  }
`;

const PageFooter = ({
  companyName,
  tone = "light",
}: {
  companyName: string;
  tone?: "light" | "dark";
}) => {
  const year = new Date().getFullYear();
  const dark = tone === "dark";

  return (
    <Wrapper className="section-lp-footer" $dark={dark}>
      <div className="inner">
        <span className="copy">
          <Feather />© {year} {companyName}
        </span>

        <span className="badges">
          <img src={nafsa} alt="NAFSA member" />
          <img src={ola} alt="Online Lenders Alliance member" />
        </span>

        <span className="links">
          <Link to={routes.TERMS_OF_USE} target="_blank">
            Terms
          </Link>
          <Link to={routes.PRIVACY_NOTICE} target="_blank">
            Privacy
          </Link>
          <Link to="/license" target="_blank">
            Details
          </Link>
        </span>
      </div>
    </Wrapper>
  );
};

export default PageFooter;
